import { setAdditionalPageInfo, setAuthenticationStatus } from './digitalDataBuilder';
import { getAnalyticsAuthenticationStatus } from './thdUserInfo';
import { buildCategoryData } from './commonAnalytics';
import { getConfig } from '../../config';

const setTheHomeDepotCategoryObject = (omsId, productName, brand, omnitureInfo = {}) => {
  setAdditionalPageInfo('category', buildCategoryData(omnitureInfo));

  const pageInfoData = {
    pageLoadEvent: 'product view',
    pageName: `productdetails>${omsId}`,
    pageType: 'pip',
  };

  setAdditionalPageInfo('pageInfo', pageInfoData);

  const itemData = {
    productInfo: {
      sku: `${omsId}`,
      productName,
      manufacturer: `${brand}`,
      productType: 'merchandise',
    },
  };

  setAdditionalPageInfo('item', itemData);
  if (getConfig()?.isDebugToConsole) {
    // eslint-disable-next-line no-console
    console.log('window.digitalData', JSON.stringify(window.digitalData));
  }
};

export const customProductPipLoaded = (omsId, productName, brand, omnitureInfo) => {
  setTheHomeDepotCategoryObject(omsId, productName, brand, omnitureInfo);
  setAuthenticationStatus(getAnalyticsAuthenticationStatus());
};

export const trackConfiguratorPageLoad = (omsId, omnitureInfo) => {
  setAdditionalPageInfo('category', buildCategoryData(omnitureInfo));

  const pageInfoData = {
    pageName: `configurator>${omsId}`,
    pageType: 'tool:custom countertops:configurator',
  };

  setAdditionalPageInfo('pageInfo', pageInfoData);

  const itemData = {
    productInfo: {
      sku: `${omsId}`,
    },
  };

  setAdditionalPageInfo('item', itemData);

  setAuthenticationStatus(getAnalyticsAuthenticationStatus());
};
